<template>
  <div class="calculator-total-wrap">
    <div
      class="calculator-total"
      :class="{'calculator-total_promocode': promocodeApplied}"
    >
      <div class="calculator-total__title">
        Стоимость доставки
      </div>
      <div class="calculator-total__info">
        <div class="calculator-total__info__cost-wrap">
          <div class="calculator-total__info__cost">
            {{ totalPrice || 0 }} {{ isDirectionKzKz ? '₸' : '₽' }}
            <span
              v-if="promocodeApplied
                && checkDeliveryMethod.discount > 0
                && checkDeliveryMethod.discount < 100"
              class="calculator-total__base"
            >
              {{ (checkDeliveryMethod.cost / (100 - checkDeliveryMethod.discount)).toFixed(2) }} {{ isDirectionKzKz ? '₸' : '₽' }}
            </span>
          </div>
          <div
            v-if="calcImport && totalPriceImport && !isDirectionKzKz"
            class="calculator-total__info__cost-currency"
          >
            <div class="calculator-total__info__cost-currency__price">
              {{ totalPriceImport }} {{ currencyName }}
            </div>
            <div class="calculator-total__info__cost-currency__text">
              Итоговая стоимость может отличаться от&nbsp;указанной&nbsp;&mdash; она зависит от&nbsp;курса банка-эмитента.
            </div>
          </div>
        </div>
        <transition
          name="fade"
          mode="out-in"
        >
          <div
            v-if="promocodeApplied && checkDeliveryMethod.discount"
            class="calculator-total__promocode"
          >
            <div class="calculator-total__promocode__desc">
              <div class="calculator-total__promocode__text">
                {{ $t('promocode') }}: <span>{{ orderCalcPIP.promo_code }}</span> применен.
              </div>
              <div class="calculator-total__promocode__discount">
                Скидка {{ checkDeliveryMethod.discount }}%
              </div>
            </div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <rect
                width="24"
                height="24"
                rx="12"
                fill="#ED1651"
              />
              <path
                d="M8.5 11C8.00555 11 7.5222 10.8534 7.11108 10.5787C6.69995 10.304 6.37952 9.91352 6.1903 9.45671C6.00108 8.99989 5.95157 8.49723 6.04804 8.01228C6.1445 7.52732 6.3826 7.08187 6.73223 6.73223C7.08187 6.3826 7.52732 6.1445 8.01228 6.04804C8.49723 5.95157 8.99989 6.00108 9.45671 6.1903C9.91352 6.37952 10.304 6.69995 10.5787 7.11108C10.8534 7.5222 11 8.00555 11 8.5C10.9993 9.16284 10.7357 9.79834 10.267 10.267C9.79834 10.7357 9.16284 10.9993 8.5 11ZM8.5 7C8.20333 7 7.91332 7.08797 7.66665 7.2528C7.41997 7.41762 7.22771 7.65189 7.11418 7.92598C7.00065 8.20007 6.97095 8.50167 7.02882 8.79264C7.0867 9.08361 7.22956 9.35088 7.43934 9.56066C7.64912 9.77044 7.91639 9.9133 8.20737 9.97118C8.49834 10.0291 8.79994 9.99935 9.07403 9.88582C9.34812 9.77229 9.58238 9.58003 9.74721 9.33336C9.91203 9.08668 10 8.79667 10 8.5C9.9996 8.1023 9.84144 7.721 9.56022 7.43978C9.279 7.15856 8.8977 7.0004 8.5 7ZM6 17.293L17.2925 6L18 6.7075L6.707 18L6 17.293ZM15.5 18C15.0055 18 14.5222 17.8534 14.1111 17.5787C13.7 17.304 13.3795 16.9135 13.1903 16.4567C13.0011 15.9999 12.9516 15.4972 13.048 15.0123C13.1445 14.5273 13.3826 14.0819 13.7322 13.7322C14.0819 13.3826 14.5273 13.1445 15.0123 13.048C15.4972 12.9516 15.9999 13.0011 16.4567 13.1903C16.9135 13.3795 17.304 13.7 17.5787 14.1111C17.8534 14.5222 18 15.0055 18 15.5C17.9993 16.1628 17.7357 16.7983 17.267 17.267C16.7983 17.7357 16.1628 17.9993 15.5 18ZM15.5 14C15.2033 14 14.9133 14.088 14.6666 14.2528C14.42 14.4176 14.2277 14.6519 14.1142 14.926C14.0007 15.2001 13.9709 15.5017 14.0288 15.7926C14.0867 16.0836 14.2296 16.3509 14.4393 16.5607C14.6491 16.7704 14.9164 16.9133 15.2074 16.9712C15.4983 17.0291 15.7999 16.9994 16.074 16.8858C16.3481 16.7723 16.5824 16.58 16.7472 16.3334C16.912 16.0867 17 15.7967 17 15.5C16.9996 15.1023 16.8414 14.721 16.5602 14.4398C16.279 14.1586 15.8977 14.0004 15.5 14Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            v-else-if="promocodeApplied && !checkDeliveryMethod.discount"
            class="calculator-total__promocode__text mb-3"
          >
            По этому промокоду нет скидки
          </div>
        </transition>
        <div class="calculator-total__delivery">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 22.5C9.9233 22.5 7.89323 21.8842 6.16652 20.7304C4.4398 19.5767 3.09399 17.9368 2.29927 16.0182C1.50455 14.0996 1.29661 11.9884 1.70176 9.95156C2.1069 7.91476 3.10693 6.04383 4.57538 4.57538C6.04383 3.10693 7.91476 2.1069 9.95156 1.70176C11.9884 1.29661 14.0996 1.50455 16.0182 2.29927C17.9368 3.09399 19.5767 4.4398 20.7304 6.16652C21.8842 7.89323 22.5 9.9233 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5ZM12 3C10.22 3 8.47992 3.52785 6.99987 4.51678C5.51983 5.50571 4.36628 6.91132 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89472 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61306 20.0518 7.32387 18.364 5.63604C16.6761 3.94822 14.387 3 12 3Z" fill="#50616F"/>
            <path d="M15.4425 16.5L11.25 12.3075V5.25H12.75V11.685L16.5 15.4425L15.4425 16.5Z" fill="#50616F"/>
          </svg>
          <div class="calculator-total__desc">
            <div class="calculator-total__delivery__title">
              Срок доставки: <span v-if="checkDeliveryMethod.time">
              {{ checkDeliveryMethod.time }}&nbsp;
              {{ num2str(checkDeliveryMethod.time, [' рабочий', ' рабочих', ' рабочих']) }}
              {{ num2str(checkDeliveryMethod.time, [' день', ' дня', ' дней']) }}
            </span>
            </div>
            <div class="calculator-total__delivery__text">
              День приема посылки - не учитывается
            </div>
          </div>
        </div>
      </div>
      <div class="calculator-total__text">
        Для оформления доставки рекомендуем зарегистрироваться в
        <a
          class="calc__link-text"
          :href="`https://lk.boxberry.ru/${UTMTags}`"
          target="_blank"
          rel="noopener"
        >
          личном кабинете
        </a>
      </div>
      <slot name="btn">
        <a
          class="calculator__button calculator__button_red"
          :class="{
            'calculator__button_loading': isLoading,
            'calculator__button_disabled': !isValid || !totalPrice
          }"
          data-step="2"
          @click.prevent="$emit('next')"
        >
          <svg
            class="arrow-icon"
            width="24px"
            height="24px"
            fill="#ffffff;"
          >
            <use xlink:href="#arrow-down" />
          </svg>
          <template v-if="calcImport">
            {{ $t('oformit-dostavku') }}
          </template>
          <template v-else>
            Оформить доставку без регистрации
          </template>
        </a>
      </slot>
    </div>

    <div class="calculator-total__text2">
      Стоимость доставки зависит от упаковки и других услуг, поэтому может меняться
    </div>
  </div>
</template>

<script>
import num2str from '../../../helpers/num2str';
import UTMTags from '../../../mixins/UTMTags';

export default {
  name: 'CalcTotal',
  mixins: [UTMTags],
  props: ['calcImport', 'orderCalcPIP',
    'promocodeSubmitted', 'checkDeliveryMethod',
    'totalPrice', 'totalPriceImport',
    'isValid', 'isLoading', 'cbrDaily', 'orderPIP', 'isDirectionKzKz'],
  data: () => ({
    num2str,
  }),
  computed: {
    promocodeApplied() {
      return this.orderCalcPIP.promo_code && this.orderCalcPIP.promo_code.length && this.promocodeSubmitted;
    },
    cbrDailySelected() {
      return this.cbrDaily.find((item) => item.numeric_code === this.orderPIP.sender.country);
    },
    currencyName() {
      if (!this.totalPrice || !this.cbrDailySelected) return '';
      return this.cbrDailySelected.symbol_code;
    },
  },
};
</script>

<style lang="scss" scoped>
.calculator-total-wrap {
  position: sticky;
  top: 165px;
}
.calculator-total {
  width: 100% !important;
  margin-bottom: 24px;
  padding: 24px;
  border-radius: 20px;
  background: #FFFFFF;
  box-shadow: 0 4px 15px 0 rgba(159, 179, 195, 0.2);
}
.calculator-total__title {
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  color: #50616F;
}
.calculator-total__text2 {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #50616F;
}
.calculator-total__text {
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  color: #50616F;
}
.calculator-total__info {
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 20px;
  background-color: rgba(159, 179, 195, 0.05);
}
.calculator-total__info__cost-wrap {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(159, 179, 195, 0.5);
}
.calculator-total__info__cost {
  display: flex;
  align-items: flex-end;
  font-size: 42px;
  font-weight: 700;
  line-height: 50px;
  color: #50616F;
}
.calculator-total__info__cost-currency {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  opacity: .8;
  color: #50616F;
}
.calculator-total__info__cost-currency__price {
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
}
.calculator-total__info__cost-currency__text {
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
}
.calculator-total__delivery {
  display: flex;
}
.calculator-total__delivery__title {
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #50616F;
  span {
    font-weight: 600;
  }
}
.calculator-total__delivery__text {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #50616F;
}
.calculator-total__desc {
  margin-left: 12px;
}
.calculator__button {
  width: 100%;
}
.calculator-total__base {
  position: relative;
  padding-bottom: 2px;
  margin-left: 5px;
  font-size: 24px;
  font-weight: 400;
  line-height: 31px;
  color: #50616F;
  opacity: .7;
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: calc(100% - 3px);
    height: 1px;
    background-color: #50616F;
  }
}
.calculator-total__promocode {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.calculator-total__promocode__desc {
  margin-right: 12px;
}
.calculator-total__promocode__text {
  font-size: 12px;
  line-height: 16px;
  color: #50616F;
  span {
    font-weight: 600;
  }
}
.calculator-total__promocode__discount {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0;
  color: #ED1651;
}
</style>
